const initState = [
    { key: 61, name: 'Account', active: true, subMenu: [] },
    { key: 62, name: 'Insurance', active: false, subMenu: [] },
    { key: 63, name: 'Codes', active: false, subMenu: [] },
    { key: 64, name: 'User Management', active: false, subMenu: [] },
    { key: 67, name: 'Rules Engine', active: false, subMenu: [] },
    { key: 68, name: 'Settings', active: false, subMenu: [] },
]


const SetupActiveTabReducer = (state = initState, action) => {
    switch (action.type) {
        case 'SetupActiveTabAction': return action.payload;
        default: return state;
    }
}
export default SetupActiveTabReducer;